import React from 'react';
import {Layout} from 'antd';
import RegisterForm from '../components/Forms/RegisterForm';
import { useTheme } from '../components/ThemeProvider';

const {Content} = Layout;

const RegisterPage: React.FC = () => {
    const { isDark } = useTheme();

    return (
        <Layout style={{minHeight: '100vh', backgroundColor: isDark ? '#141414' : '#f0f2f5'}}>
            <Content style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '24px'
            }}>
                <RegisterForm/>
            </Content>
        </Layout>
    );
};

export default RegisterPage;